import SecondaryDominantInput from "./SecondaryDominantInput";
import QuestionLayout from "./QuestionLayout";

export default function TwoBlankWidget({
  config,
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  if(config.variant === "secondary-dominant")return <SecondaryDominantInput config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>;
  function update(id, text) {
    onChange({
      ...value,
      [id]: text
    });
  }

  function inputStyle(id) {
    if (mode !== "review") {
      return {
        border: "1px solid #aaa"
      };
    }

    const part = feedback?.parts?.[id];

    return {
      border: `2px solid ${part?.correct ? "#2e7d32" : "#c62828"}`
    };
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      <div
        style={{
          marginTop: 16,
          textAlign: "center",
          fontSize: 22
        }}
      >
        A staff has{" "}
        <input
          type="text"
          value={value.first || ""}
          disabled={mode !== "edit"}
          onChange={(e) => update("first", e.target.value)}
          style={{
            width: 50,
            textAlign: "center",
            fontSize: 22,
            borderRadius: 4,
            ...inputStyle("first")
          }}
        />{" "}
        lines and{" "}
        <input
          type="text"
          value={value.second || ""}
          disabled={mode !== "edit"}
          onChange={(e) => update("second", e.target.value)}
          style={{
            width: 50,
            textAlign: "center",
            fontSize: 22,
            borderRadius: 4,
            ...inputStyle("second")
          }}
        />{" "}
        spaces.
      </div>
    </QuestionLayout>
  );
}